export const souveraenitaetKomplexitaetFAQData = [
  {
    question: 'Warum brauche ich einen Katalysator, wenn ich bereits eine Strategie habe?',
    answer: 'Eine Strategie ist eine Landkarte (Kognition). Das Gehen des Weges erfordert jedoch Energie. Wenn emotionale oder systemische Blockaden die Aktivierungsenergie zu hoch treiben, bleibt die Strategie Theorie. Der Katalysator senkt diese Hürde, damit aus Wissen Handeln wird.'
  },
  {
    question: 'Ist die Katalysator-Methode eine Form von Therapie?',
    answer: 'Nein. Es ist ein hochspezialisiertes Coaching für den unternehmerischen Kontext. Während Therapie oft Vergangenes heilt, nutzt die Katalysator-Methode neurobiologische Erkenntnisse, um die aktuelle Handlungsfähigkeit und Souveränität in komplexen Entscheidungssituationen wiederherzustellen.'
  },
  {
    question: 'Wie unterscheidet sich dieser Ansatz von klassischer Unternehmensberatung?',
    answer: 'Berater bringen oft fertige Skripte und Lösungen von außen („Push"). Mein Ansatz als Katalysator ist die Entwicklung von innen heraus („Pull"). Wir arbeiten an der Resonanzfähigkeit der Führungskraft und der Kultur, damit das System sich selbst effizienter steuert.'
  },
  {
    question: 'Warum spielt die „erhöhte Wahrnehmung" eine Rolle im Executive Coaching?',
    answer: 'Führungskräfte mit feinen Antennen nehmen oft Spannungen und systemische Fehler wahr, bevor sie in den Daten auftauchen. Wenn dieser Input nicht konstruktiv genutzt wird, führt er zu Überlastung. Wir wandeln diese Wahrnehmung in eine präzise Management-Ressource um.'
  },
  {
    question: 'Wie lange dauert es, bis die „Betonwand" verschwindet?',
    answer: 'Oft reicht ein einziger Impuls (ein Katalysator-Moment), um die energetische Barriere zu senken. Das Ziel ist nicht die endlose Begleitung, sondern die punktgenaue Intervention, die den Prozess wieder ins Fließen bringt.'
  }
];
